import { cn } from "@/lib/chillnn/cn";

import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionReservationLocalPaymentCancelFeeTransferInfo } from "./local-payment-cancel-fee-transfer-info";
import { QuestionReservationLocalPaymentCancelFeeTransferLimitDays } from "./local-payment-cancel-fee-transfer-limit-days";
import { useAccommodationHotelPolicyFormModelContext } from "../../../../../context";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../../store/categories";

type Props = {
	reservationLocalPaymentSettings: HotelPolicyCategoriesAndManagerStore["reservationLocalPaymentSettings"];
};

export const IslandQuestionReservationLocalPaymentCancelFee = ({ reservationLocalPaymentSettings }: Props) => {
	const {
		viewModel: {
			isLocalPaymentAvailable: { value: isLocalPaymentAvailable },
		},
	} = useAccommodationHotelPolicyFormModelContext();

	return (
		// 「現地決済を利用可能にする」が有効な場合は 下記設定が未入力だと invalid だが 、無効な場合は valid な状態になる
		// 「現地決済を利用可能にする」都合でバリデーションの条件が変化した場合に、DOMから削除してしまうと
		// バリデーションの条件が変化したことをユーザーに伝えることができないため、visually-hidden で非表示にしている
		<div className={cn(!isLocalPaymentAvailable && " visually-hidden")}>
			<FeatureIslandMainWithCategoryWrapper
				islandTitle="追加設定"
				categoryStore={reservationLocalPaymentSettings}
			>
				<QuestionReservationLocalPaymentCancelFeeTransferLimitDays />
				<QuestionReservationLocalPaymentCancelFeeTransferInfo />
			</FeatureIslandMainWithCategoryWrapper>
		</div>
	);
};

IslandQuestionReservationLocalPaymentCancelFee.displayName = "IslandQuestionReservationLocalPaymentCancelFee";
